import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Same scheme as the admin portal and the embed: local dev gets the cyan mark
// in the browser tab so a localhost app is easy to tell apart from prod at a
// glance. Prod keeps the black icon from index.html.
const host = window.location.hostname;
if (host === 'localhost' || host === '127.0.0.1') {
  document.querySelectorAll('link[rel~="icon"]').forEach((link) => {
    link.href = `${process.env.PUBLIC_URL}/favicon-local.png`;
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
